import React from 'react'
import '../styles/container.css';
import IconButton from '@material-ui/core/IconButton';
import { MdClose, MdMenu } from 'react-icons/md'

//Redux
import { connect } from 'react-redux';

const mapStateToProps = state => ({
    usuarioActivo: state
});


let container = (props) => {
	
	const isLoginPage = props.currentPath === '/' || props.currentPath === '/login';

    return (
        <React.Fragment>
			{!isLoginPage && (
				<div className="page-title-wrapper">
					<div className="menu-hamburger">
						<div className={"page-title-icon-custom"}>
							<IconButton	aria-label="Download" onClick={() => props.toggleMenu()}>
								{ props.menuVisible ? <MdClose color={'white'} /> : <MdMenu color={'white'} /> }
							</IconButton>
							<span className='span-label' onClick={() => props.toggleMenu()} title="Abrir / Cerrar menú"> Menú </span>
						</div>
					</div>
					<div className="page-title-logo">
						<img 
							src="https://confipetrol.com/wp-content/uploads/2025/02/LOGO-CONFIPETROL-271x90.png" 
							alt="Confipetrol" 
							className="confipetrol-logo" 
						/>
					</div>
				</div>
			)}
            <div className={"container-area"}>
                <div className={"children-container"}>
                    {props.children}
                </div>
            </div>
        </React.Fragment>
    )
}

export default connect(mapStateToProps)(container)